import { CommonWrap, ComomonAlert } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";
import { useLocales } from "@/locales";
import CodeSnippet from "@/components/CodeSnippet";
import ShowTable from "@/DocLayout/Table/index";
import { USER_SWAP_RECORD_LIST } from "@/config";
import { codeMap } from "@/PageCodeComponents/PublicResourceApi";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { useContext } from "react";
import PostRequest from "@/components/PostRequest";
import { useAuthContext } from "@/auth/useAuthContext";

export default function GetUserSwapRecoredList() {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  const user_swap_record_list = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "records": [
        {
          "recordId": "20240722021342166923068583059456",
          "orderId": "1721614421267",
          "coinInSymbol": "USDT",
          "coinIdIn": 1280,
          "coinOutSymbol": "MATIC",
          "coinIdOut": 1329,
          "amountOut": "1.8174262160994585",
          "amountIn": "1.000000000000000000000000",
          "netAmountOut": "1.634953704442886400000000",
          "userId": "user-swap1",
          "extraFee": "0",
          "extraFeeRate": "0",
          "swapRate": "1.817426216099458500000000",
          "feeRate": "0.1004016064257028",
          "fee": "0.182472511656572100000000",
          "status": "Success",
          "createdAt": 1721614422,
          "arrivedAt": 1721614422
        },
        ...
      ],
      "nextId": ""
    }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
      "bytes"
      "crypto/hmac"
      "crypto/sha256"
      "encoding/hex"
      "fmt"
      "io"
      "net/http"
      "time"
  )
  
  func main() {
  
      appId := "*** your appId ***"
      appSecret := "*** your appSecret ***"
  
      // With request params
      path := "${check ? USER_SWAP_RECORD_LIST : "***"}" 
      args := []byte("")                                                                
  
      //sign
      timestamp := time.Now().Unix()
      signText := fmt.Sprintf("%s%d", appId, timestamp)
      if len(args) != 0 {
         signText = fmt.Sprintf("%s%s", signText, args)
      }
  
      h := hmac.New(sha256.New, []byte(appSecret))
      h.Write([]byte(signText))
      sign := hex.EncodeToString(h.Sum(nil)[:])
  
      fmt.Printf("Sign: %s", sign)
  
      // Making API call
      client := http.Client{}
      request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
      request.Header.Set("AppId", appId)
      request.Header.Set("Sign", sign)
      request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
      resp, _ := client.Do(request)
  
      defer resp.Body.Close()
      respBytes, _ := io.ReadAll(resp.Body)
      fmt.Printf("Resp: %s", respBytes)
  }`,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
      public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
          String appId = "*** your appId ***";
          String appSecret = "*** your appSecret ***";
          // With request params
          String path = "${check ? USER_SWAP_RECORD_LIST : "***"}";
  
          byte[] requestBody = "".getBytes(StandardCharsets.UTF_8);
          // Sign
          long timestamp = new Date().getTime() / 1000L;
          String signText = appId + timestamp;
          if (requestBody.length != 0) {
              signText += new String(requestBody, StandardCharsets.UTF_8);
          }
          Mac sha256Hmac = Mac.getInstance("HmacSHA256");
          SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
          sha256Hmac.init(secretKey);
          byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
          String sign = byteArrayToHexString(signBytes);
  
          // Making API call
          HttpClient client = HttpClientBuilder.create().build();
          HttpPost request = new HttpPost(path);
          request.setHeader("AppId", appId);
          request.setHeader("Sign", sign);
          request.setHeader("Timestamp", String.valueOf(timestamp));
          request.setEntity(new ByteArrayEntity(requestBody));
          HttpResponse response = client.execute(request);
          BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
          StringBuilder responseText = new StringBuilder();
          String line;
          while ((line = reader.readLine()) != null) {
              responseText.append(line);
          }
          reader.close();
  
          // result
          System.out.println("Resp: " + responseText);
      }
  
      private static String byteArrayToHexString(byte[] bytes) {
          StringBuilder hs = new StringBuilder();
          String tempStr;
          for (int index = 0; bytes != null && index < bytes.length; index++) {
              tempStr = Integer.toHexString(bytes[index] & 0XFF);
              if (tempStr.length() == 1) {
                  hs.append('0');
              }
              hs.append(tempStr);
          }
          return hs.toString().toLowerCase();
      }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your appId ***"
  app_secret = "*** your appSecret ***"
  url = "${check ? USER_SWAP_RECORD_LIST : "***"}"
  content = {}
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
      sign_text = f"{sign_text}{body}"
  else:
      body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
                      headers={
                          "Content-Type": "application/json;charset=uf8",
                          "Appid": app_id,
                          "Sign": server_sign,
                          "Timestamp": f"{timestamp}"},
                      data=body
                      )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require('https');
  const crypto = require('crypto');
  
  const appId = '*** your appId ***';
  const appSecret = '*** your appSecret ***';
  
  const path = '${check ? USER_SWAP_RECORD_LIST : "***"}';
  const args = '';
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac('sha256', appSecret)
    .update(signText)
    .digest('hex');
  
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'AppId': appId,
      'Sign': sign,
      'Timestamp': timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = '';
  
    res.on('data', (chunk) => {
      respData += chunk;
    });
  
    res.on('end', () => {
      console.log('Response:', respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your appId ***";
  $app_secret = "*** your appSecret ***";
  $url = "${check ? USER_SWAP_RECORD_LIST : "***"}";
  $content = array();
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
      $sign_text = $sign_text . $body;
  } else {
      $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
      "headers" => array(
          "Content-Type: application/json;charset=utf-8",
          "Appid: " . $app_id,
          "Sign: " . $server_sign,
          "Timestamp: " . $timestamp
      ),
      "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <>
      <ContentWrap
        id="user-swap-record-list"
        showBorderBottom={false}
        leftChildrenSx={{
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box
              id="user-swap-record-list"
              component={"div"}
              className="title_0"
              mt={3}
            >
              {translate("merchant_user_wallet_mode_API.text_113")}
            </Box>

            <Box component={"div"} className="desc" mt={3}>
              {translate("merchant_user_wallet_mode_API.text_114")}
            </Box>

            <Box component={"div"} className="title_1" mt={3}>
              {translate("common.http_request")}
            </Box>

            <Box component={"div"} className="desc" mb={3}>
              <PostRequest url={USER_SWAP_RECORD_LIST} />
            </Box>
          </CommonWrap>
        }
      />
      <ContentWrap
        showBorderBottom={false}
        leftChildrenSx={{
          paddingTop: "32px",
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_params")}</Box>
            <ShowTable
              tableData={[
                {
                  name: "recordIds",
                  type: "Array[string]",
                  is_: translate("common.params_no"),
                  desc: translate("merchant_app_mode_API.text_122"),
                },
                {
                  name: "orderIds",
                  type: "Array[string]",
                  is_: translate("common.params_no"),
                  desc: `${translate("merchant_app_mode_API.text_123")}`,
                },
                {
                  name: "userId",
                  type: "String",
                  is_: translate("common.params_no"),
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_102"
                  )}`,
                },
                {
                  name: "coinIdIn",
                  type: "Integer",
                  is_: translate("common.params_no"),
                  desc: `${translate("merchant_app_mode_API.text_99")}`,
                },
                {
                  name: "coinIdOut",
                  type: "Integer",
                  is_: translate("common.params_no"),
                  desc: `${translate("merchant_app_mode_API.text_100")}`,
                },
                {
                  name: "startAt",
                  type: "Integer",
                  is_: translate("common.params_no"),
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_124"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: translate("common.params_no"),
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_125"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: translate("common.params_no"),
                  desc: translate(
                    `${
                      currentLang.value === "en"
                        ? "merchant_app_mode_API.text_126"
                        : "merchant_user_wallet_mode_API.text_30"
                    }`
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_31"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_request_ex")}
              code={user_swap_record_list[language].http_ex_code}
            />
          </>
        }
      />

      {/* 返回参数 */}

      <ContentWrap
        leftChildrenSx={{
          paddingTop: "2px",
        }}
        leftChildren={
          <CommonWrap>
            <Box component={"div"} className="title_1" mt={3}>
              {translate("common.http_res")}
            </Box>

            <ShowTable
              res={true}
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: " ",
                },
                {
                  name: "data.records",
                  type: "Array",
                  desc: " ",
                },
                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "data.records[index].orderId",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_128"),
                },
                {
                  name: "data.records[index].coinInSymbol",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_129"),
                },
                {
                  name: "data.records[index].coinIdIn",
                  type: "Integer",
                  desc: translate("merchant_app_mode_API.text_99"),
                },
                {
                  name: "data.records[index].coinOutSymbol",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_130"),
                },
                {
                  name: "data.records[index].coinIdOut",
                  type: "Integer",
                  desc: translate("merchant_app_mode_API.text_100"),
                },
                {
                  name: "data.records[index].amountOut",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_131"),
                },
                {
                  name: "data.records[index].netAmountOut",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_140"),
                },
                {
                  name: "data.records[index].amountIn",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_132"),
                },
                {
                  name: "data.records[index].userId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_102"
                  )}`,
                },
                {
                  name: "data.records[index].swapRate",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_105"),
                },
                {
                  name: "data.records[index].feeRate",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_133"),
                },
                {
                  name: "data.records[index].fee",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_104"),
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_114"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.records[index].createdAt",
                  type: "Integer",
                  desc: translate("merchant_app_mode_API.text_115"),
                },
                {
                  name: "data.records[index].arrivedAt",
                  type: "Integer",
                  desc: translate("merchant_app_mode_API.text_116"),
                },
                {
                  name: "data.records[index].amountOutMinimum",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_117"),
                },
                {
                  name: "data.records[index].extraFee",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_119"),
                },
                {
                  name: "data.records[index].extraFeeRate",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_134"),
                },
                {
                  name: "data.nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            `merchant_user_wallet_mode_API.${
                              currentLang?.value === "en"
                                ? "text_32"
                                : "text_30_"
                            }`
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_result")}
              code={codeMap["user_swap_record_list"].response}
            />
          </>
        }
      />
    </>
  );
}
